import { Fragment } from "react"

export default function Error({ certificate_type, errorMsg, setPopup }) {
    return (
        <Fragment>
            <div className="text-[1.5rem] font-semibold mb-2">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && '獲獎證明'} 申請失敗
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-9">
                {errorMsg}
            </div>
            <button
                type="button"
                className="w-full btn-black btn-round"
                onClick={() => { setPopup(null) }}
            >關閉</button>
        </Fragment>
    )
}